import React, { Component } from 'react';
import PropTypes from 'prop-types';


import classNames from 'classnames';
import Drawer from '@mui/material/Drawer';
//import {spacing, typography} from '@mui/material/styles';
import {red} from '@mui/material/colors';
//import Menu from '@mui/material/Menu';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
//import GridOff from '@mui/icons-material/GridOff';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DynamicMenu from '../menu/sidemenu/DynamicMenu';
import { Box, styled, Typography, type Theme } from '@mui/material';
//import ServiceList from './ServiceList';

//injectTapEventPlugin();

const drawerWidth = 240;
const miniDrawerWidth = 60;

const s:any = {
  
  menuButton: {
    marginLeft: 1, //12,
    marginRight: 1, //36,
  },
  hide: {
    display: "none",
  },
  rootPaper: {
    position: "relative",
  },
  drawerPaper: (theme:Theme)=>({
    [theme.breakpoints.down('sm')]:{
      width: miniDrawerWidth,
      overflowX: 'hidden',
    },
    position: 'relative',
    whiteSpace: 'nowrap',
    height: '100%',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  drawerPaperClose: {
    width:0,
  },
  drawerHeader: (theme:Theme)=>({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '64px',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }),
  logo: (theme:Theme)=>({
    cursor: 'pointer',
    fontSize: 22,
    color: 'common.white',
    fontWeight: 'typography.fontWeightLight',
    backgroundImage: 'url(lib/img/logo.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left center',
    backgroundColor: 'transparent',
    paddingLeft: 2,
    paddingRight: 2,
    height: 56,
    width: 'auto',
    minWidth: 120,
    maxWidth: drawerWidth - 60,
    display: 'block',
  }),
  avatarDiv: {
    padding: '15px 0 20px 10px',
    height: 45
  },
  avatarIcon: {
    float: 'left',
    display: 'block',
    marginRight: 1, //15
    boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.2)'
  },
  avatarSpan: {
    paddingTop: 1, //12
    display: 'block',
    color: 'white',
    fontWeight: 300,
    textShadow: '1px 1px #444'
  },
  adminMenu:{
    color:red
  },
  userMenu:{
    fontWeight: 'typography.fontWeightLight',
  }
};

const DrawerHead = styled('div')(({ theme }) => theme.mixins.toolbar);

class LeftDrawer extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      selectedItem: null
    };
  }

  menuname=(menu:string)=>{
    return menu.replace('/','');
  }

  handleClick = (menu:any,page:any,index:any)=> () => {
    console.log('handleclick:menu,page,index',menu,page,index);
    this.props.handleSetContent(null,page).then( () => {
      this.props.closeDrawer();
    });
    
  }

  render(){
    const { data, navDrawerOpen, closeDrawer, classes, theme } = this.props;
    //const eti = (data.bd||{}).eti; 
    const unm = (data.bd||{}).unm; 

    //console.log('data:',data);
    const avatarsrc = `/api/photo/${unm}`;
    const logosrc = `/api/logo/logo.png`;
    //console.log('servicelist',ServiceList());

    return (
      <Drawer
        variant="persistent"
        open={navDrawerOpen}
        onClose={closeDrawer}
        PaperProps={{
          sx: (theme) => ({
            ...s.drawerPaper(theme),
            width: navDrawerOpen ? drawerWidth : 0,
            overflowX: 'hidden',
          })
        }}
        sx={{
          width: navDrawerOpen ? drawerWidth : 0,
          flexShrink: 0,
        }}
      >
      <Box>
        <DrawerHead sx={{...s.drawerHeader}}>
          <Box 
            sx={{
              ...s.logo,
              
              display: navDrawerOpen ? 'block' : 'none',
              flex: 1,
            }} 
          />
          <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <img src={logosrc} alt="logo" style={{display: navDrawerOpen ? 'block' : 'none', height:46, marginRight:8}} /> 
            <Box>
              <Typography>Sakumono Corpus </Typography> 
              <Typography>Christi Management</Typography>
            </Box>
          </Box>
          {/* <IconButton onClick={closeDrawer} sx={{ ml: 'auto' }}>
            <ChevronRightIcon /> 
          </IconButton>  */}
        </DrawerHead>
        
        <Divider />
        <Box sx={{...s.avatarDiv}}>
          <Avatar src={avatarsrc} sx={{...s.avatarIcon}}>
          </Avatar>
          <Box component='span' sx={{...s.avatarSpan,...(!navDrawerOpen?s.hide:{})}}>{this.props.username}</Box>
        </Box>
        <Divider />
        <DynamicMenu data={data} handleClick={this.handleClick}/>
        {/* <Divider />
        <StaticMenu data={data} menus={menus} value={this.state.selectedItem} onClick={this.handleClick} onChange={handleSetContent} /> */}
      </Box>
    </Drawer>
    );
  }
}

LeftDrawer.propTypes = {
  navDrawerOpen: PropTypes.bool,
  menus: PropTypes.array,
  username: PropTypes.string,
  data: PropTypes.object,
  handleSetContent:PropTypes.func
};

export default LeftDrawer;
